export enum EnvironmentConsts {
  DEV = 'DEV',
  TEST = 'TEST',
  PROD = 'PROD'
}
